import React from 'react';

import { IBaseProps } from '../utils';

import styles from './LoadingSpinner.module.scss';

export interface ILoadingSpinnerProps extends IBaseProps {
  /** Message that is displayed with the spinner */
  message?: string;
  /** Defines the style variant of the LoadingSpinner */
  variant?: 'inline' | 'page';
}

export const LoadingSpinner: React.FC<ILoadingSpinnerProps> = ({
  message = '',
  variant = 'inline',
  className = '',
  dataTest = 'loading-indicator'
}) => {
  const variantStyles = styles[variant];

  return (
    <div className={`${styles.container} ${variantStyles} ${className}`} data-test={dataTest}>
      <div className={styles.spinnerPositioner}>
        <div className={styles.spinnerBase} />
        <div className={styles.spinner} />
      </div>
      <div data-test={`${dataTest}-message`} className={styles.message}>
        {message}
      </div>
    </div>
  );
};

LoadingSpinner.defaultProps = {
  className: '',
  dataTest: 'loading-indicator',
  message: '',
  variant: 'inline'
};
